export default "__VITE_ASSET__e09136db__"